import { createStyles, Theme } from '@zn-material-ui'
import logoImage from '@images/homepage/home_icon_logo.png'
import messageImage from '@images/homepage/home_icon_message.png'
import picketImage from '@images/homepage/home_icon_picket.png'

export default (theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      backgroundColor: theme.palette.secondary.main,
      boxShadow: '0 1px 1px 0 rgba(0,0,0,0.30)',
      position: 'fixed',
      zIndex: theme.zIndex.appBar,
      top: 0,
      left: 0,
      '& header': {
        width: '1200px',
        boxShadow: 'none !important',
      },
    },
    appBar: {
      margin: '0 auto',
      width: '100%',
    },
    toolbar: {
      paddingLeft: 0,
      paddingRight: 0,
    },
    grow: {
      flexGrow: 1,
    },
    logo: {
      width: '88px',
      height: '30px',
      background: `url(${logoImage}) no-repeat`,
      display: 'inline-block',
      backgroundSize: '88px 30px',
    },

    toolsItem: {
      cursor: 'pointer',
      marginRight: '40px',
      fontSize: 12,
      color: theme.palette.text.primary,
      display: 'flex',
      alignItems: 'center',
      height: 30,
      '& a': {
        width: '100%',
        height: '100%',
        display: 'inline-block',
      },
    },
    packetImg: {
      display: 'inline-block',
      width: 20,
      height: 20,
      background: `url(${picketImage}) no-repeat 0 0/20px 20px`,
      marginRight: '10px',
    },
    messageImg: {
      position: 'relative',
      display: 'inline-block',
      width: 20,
      height: 20,
      background: `url(${messageImage}) no-repeat 0 0/20px 20px`,
      marginRight: '10px',
    },

    count: {
      position: 'absolute',
      backgroundColor: theme.palette.primary.main,
      width: '6px',
      height: '6px',
      borderRadius: '50%',
      display: 'inline-block',
      right: -5,
      top: -5,
    },

    userInfo: {
      cursor: 'pointer',
      display: 'inline-block',
      width: '30px',
      height: '30px',
      borderRadius: '50%',
    },

    title: {
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
      height: '34px',
    },

    sectionDesktop: {
      width: '462px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },

    list: {
      marginLeft: -120,
      marginTop: 15,
    },

    userName: {
      marginLeft: 10,
      width: 50,
      fontSize: 12,
      textAlign: 'center',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  })
